const GetLocalStorageKey = (key) => {
  return window.localStorage.getItem(key);
};

const DeleteLocalStorageKey = (key) => {
  window.localStorage.removeItem(key);
};

const ClearLocalStorage = () => {
  window.localStorage.clear();
};

const SetLocalStorageKey = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

const SetPlanId = (planID) => {
  console.log(`Setting planID: ${planID}`);
  window.localStorage.setItem("SelectedPlanID", planID);
};

const GetPlanId = () => {
  console.log(`Getting planID`);
  return window.localStorage.getItem("SelectedPlanID");
};

export {
  ClearLocalStorage,
  DeleteLocalStorageKey,
  GetLocalStorageKey,
  SetLocalStorageKey,
  SetPlanId,
  GetPlanId,
};
